module.exports = __webpack_public_path__ + "static/img/1_24_1.67c1a556.png";